import {Time} from 'yougile-util'
import {DealActivityDealItem} from 'yougile-model'
import {isThatDay} from './custom-format-date'

const textColors = {
  green: 'text-sticker-green',
  red: 'text-sticker-red2',
  grey: 'text-secondary'
}

const bgColors = {
  green: 'bg-sticker-green',
  red: 'bg-sticker-red',
  grey: 'bg-sticker-gray'
}

export const getDealActivityColor = (
  activity: DealActivityDealItem
): string => {
  const color = getBaseDealActivityColor(activity)
  return textColors[color]
}

export const getDealActivityDeadlineColor = (deadline: number): string => {
  const color = getBaseDealDeadlineColor(deadline)
  return textColors[color]
}

export const getDealActivityColors = (
  activity: DealActivityDealItem
): {text: string; bg: string} => {
  const color = getBaseDealActivityColor(activity)
  return {text: textColors[color], bg: bgColors[color]}
}

export const getBaseDealActivityColor = (
  activity: DealActivityDealItem
): 'green' | 'red' | 'grey' => {
  if (activity.completed) {
    if (!activity.completedModified) {
      return 'grey'
    }

    const diff = activity.deadline - activity.completedModified
    return diff >= 0 ? 'green' : 'red'
  }

  return getBaseDealDeadlineColor(activity.deadline)
}

export const getBaseDealDeadlineColor = (
  deadline: number
): 'green' | 'red' | 'grey' => {
  if (Time.now() - deadline > 0) {
    return 'red'
  }

  if (isThatDay(deadline, 'current')) {
    return 'green'
  }

  return 'grey'
}
